export default "assets/images/icons/login-23846a43.svg";